export default __webpack_public_path__ + "8e5621b2012f373fe96e27cf134bcdc1.woff2";